"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _icon = _interopRequireDefault(require("../icon"));

var _controlLegend = _interopRequireDefault(require("../control-legend"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ControlCheckboxSet extends _react.default.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onChange", e => {
      const current = e.target.value;
      const {
        value
      } = this.props;
      const index = value.indexOf(current);
      const newValue = value;

      if (index === -1) {
        newValue.push(current);
      } else {
        newValue.splice(index, 1);
      }

      return this.props.onChange(newValue, this.props.id);
    });
  }

  render() {
    const {
      id,
      value,
      legend,
      options,
      optional,
      aside,
      autoFocus,
      icon,
      validationError,
      themeCheckboxContainer,
      themeCheckbox,
      themeControlWrapper,
      themeLegend
    } = this.props;
    const groupProps = {
      id,
      'data-test': `${id}-input`
    };

    if (validationError) {
      groupProps['aria-invalid'] = true;
    }

    const renderOptions = d => {
      const isActive = value.indexOf(d.value) >= 0 ? true : false;
      const extraProps = (0, _omit.default)(d, ['value', 'label']);
      return /*#__PURE__*/_react.default.createElement("label", {
        key: d.value,
        className: `checkbox-container ${themeCheckboxContainer}`
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        value: d.value,
        checked: isActive,
        "aria-checked": isActive,
        autoFocus: autoFocus && isActive,
        onChange: this.onChange,
        name: id,
        role: "checkbox",
        type: "checkbox"
      }, extraProps)), /*#__PURE__*/_react.default.createElement("div", {
        className: `${themeCheckbox} checkbox`
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: icon
      })), d.label);
    };

    return /*#__PURE__*/_react.default.createElement(_controlWrapper.default, {
      themeControlWrapper: themeControlWrapper,
      id: id,
      validationError: validationError
    }, /*#__PURE__*/_react.default.createElement("fieldset", null, legend && /*#__PURE__*/_react.default.createElement(_controlLegend.default, {
      text: legend,
      id: id,
      aside: aside,
      optional: optional,
      themeLegend: themeLegend
    }), /*#__PURE__*/_react.default.createElement("div", groupProps, options.map(renderOptions))));
  }

}

exports.default = ControlCheckboxSet;

_defineProperty(ControlCheckboxSet, "propTypes", {
  /** Unique id for this control. */
  id: _propTypes.default.string.isRequired,

  /**
   * An array of object(s) that represent each option of the set.
   * Each object should contain two fields:
   *
   * - `label` which can either be a string or valid JSX
   * - `value` a unique string value
   *
   * Any additional fields added will be passed as attributes to the input
   * element.
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node.isRequired,
    value: _propTypes.default.string.isRequired
  })).isRequired,

  /**
   * Invoked when the control's value changes.
   * Passed two arguments:
   *
   * - The value. A string matching the `value` field of one of the `options`
   *   props passed.
   * - The `id` prop.
   */
  onChange: _propTypes.default.func.isRequired,

  /** Legend label for the control. */
  legend: _propTypes.default.string,

  /** Accepts an array of strings, where each string matches the value property of an entry in the options prop. */
  value: _propTypes.default.array,

  /** If provided, "(optional)" is appended to the value of the legend element. */
  optional: _propTypes.default.bool,

  /** Additional content inserted alongside the legend element. */
  aside: _propTypes.default.node,

  /** Icon to use for the checkbox active style. Must match an icon name available in Assembly. */
  icon: _propTypes.default.string,

  /** When `true`, autofocus attributes are applied to the input that matches the `value` prop passed. */
  autoFocus: _propTypes.default.bool,

  /** A validation error to display beneath the control. */
  validationError: _propTypes.default.node,

  /** Classes to apply to the checkbox container. */
  themeCheckboxContainer: _propTypes.default.string,

  /** Classes to apply to the checkbox element. */
  themeCheckbox: _propTypes.default.string,

  /** Classes to apply to the control container. */
  themeControlWrapper: _propTypes.default.string,

  /** Classes to apply to the legend element. */
  themeLegend: _propTypes.default.string
});

_defineProperty(ControlCheckboxSet, "defaultProps", {
  value: [],
  optional: false,
  autoFocus: false,
  icon: 'check',
  themeCheckboxContainer: 'txt-s block mb6 flex',
  themeCheckbox: 'mr6 inline-block checkbox--blue checkbox--s-label'
});